export default {
  vapid: {
    public: {
      key: process.env.VUE_APP_VAPID_PUBLIC_KEY
    }
  }
}
